<template>
  <div>
    <div class="head__wrapper">
      <span class="title-text">{{
        $l('title_text_proof_product_fabric') || '打样产品面料'
      }}</span>
      <el-button
        type="primary"
        plain
        size="mini"
        class="ml-3"
        @click="onOpenChooseFabricColor"
        v-if="!disabled"
        >{{ $l('btn_choose_fabric_flower') || '选择面料颜色或花型' }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onOpenChooseFabricColor() {
      this.$emit('openChooseFabricColor')
    },
  },
}
</script>
<style lang="scss" scoped>
.head__wrapper {
  display: flex;
  align-items: center;
  .title-text {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
  }
}
</style>
